<template>
  <UiCard :height="height">
    <template #image v-if="!noimg">
      <BaseLink class="card-image" :nolink="nolink" :to="e.internalLink">
        <UiImageSelection
          :image="e.image"
          :type="type"
          :cover-override="false"
          :appearance="{
            borderRadius: 'small',
            hoverScale: true,
          }"
          image-usage="thumbnail"
        />
      </BaseLink>
    </template>
    <template #title>
      <BaseLink :nolink="nolink" :to="e.internalLink">{{ ls(e.title) }}</BaseLink>
    </template>
    <template #owner v-if="isJps && owner && e.ownerOrgId">
      <UiOrgSpan :id="e.ownerOrgId"></UiOrgSpan>
    </template>
    <template #record-count v-if="isHina && type === 'database'">
      <span>{{ ls(dapLangGlobal.db.recordCount) }}: {{ num(data.recordCount) }}</span>
    </template>
    <p>{{ ls(e.description) }}</p>
    <template #interact>
      <UiInteractPanel :type="type" :data="data" :image="e.image" />
    </template>
  </UiCard>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { ls, num } = useI18n()
const { isHina, isJps } = useServiceType()
const { dataToListElement } = useListElement()

interface Props {
  nolink?: boolean
  noimg?: boolean
  owner?: boolean
  data: any
  type: Key
  height?: 'auto' | 'middle'
}
const props = withDefaults(defineProps<Props>(), {
  nolink: false,
  noimg: false,
  owner: false,
})

const e = computed(() => {
  return dataToListElement(props.type, props.data)
})
</script>
